/* CopyAction.js */

"use strict";
const {get, isNumber} = require("lodash");
const DevicesListComponent = require("./devicesList/devicesListComponent");
const ProgressComponent = require("./progress/ProgressComponent");
const SummaryComponent = require("./summary/SummaryComponent");

class CopyAction {
    constructor(
        userSession,
        logger,
        gameEditor,
        userFeedback,
        activeView,
        DeviceEntity,
        licenseRestriction
    ) {
        this._userSession = userSession;
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = userFeedback;
        this._activeView = activeView;
        this._deviceEntityDef = DeviceEntity;
        this._licenseRestriction = licenseRestriction;
        this._progressComponent = new ProgressComponent(this._gameEditor);
        this._activeOrgId = get(this._userSession, "activeOrganization.id", "");

        this.run = this.run.bind(this);
    }

    async _showProgressVeil() {
        await this._modalUserFeedback.displayCustom(this._progressComponent, {
            notDismissable: false,
            dontHide: true,
        });
    }

    run() {
        document.querySelector(".iot-device-explorer-entity-lmrb").classList.add("copy-from-veil");
        return this._modalUserFeedback
            .displayCustom(
                new DevicesListComponent(
                    this._activeView.getSelectedDeviceIds().selectedRows || [],
                    this._deviceEntityDef,
                    this._userSession,
                    this._licenseRestriction,
                    this._modalUserFeedback,
                    this._logger
                ),
                {dontHide: true}
            )
            .then(async (result) => {
                const workResult = await Promise.race([
                    this.copyDeviceProperties(result.selectedDevice, result.selectedDevices),
                    this._showProgressVeil(),
                ]);

                await this._modalUserFeedback.displayCustom(
                    new SummaryComponent(workResult, this._logger)
                );
                document
                    .querySelector(".iot-device-explorer-entity-lmrb")
                    .classList.remove("copy-from-veil");
            })
            .catch(() => {
                document
                    .querySelector(".iot-device-explorer-entity-lmrb")
                    .classList.remove("copy-from-veil");

                this._modalUserFeedback.hideDisplayed();
            });
    }

    async copyDeviceProperties(selectedDeviceId, selectedDevicesIds) {
        const progressCallBack = ({workId, successCount, failureCount, targetCount}) => {
            if (isNumber(successCount) && isNumber(failureCount) && isNumber(targetCount)) {
                const msg = `Succeeded ${successCount}, failed ${failureCount} of ${targetCount} devices`;
                this._progressComponent.emit("progress", workId, msg);
            }
        };

        const copyTarget = {
            method: "multi",
            ids: selectedDevicesIds,
        };

        const copyInput = {
            fromDeviceId: selectedDeviceId,
        };
        const copyResults = await this._deviceEntityDef.runOdmCopyDiscoveryWork(
            this._activeOrgId,
            copyTarget,
            copyInput,
            {launchAndForget: false},
            progressCallBack
        );

        return Promise.resolve(copyResults);
    }
}

module.exports = CopyAction;

CopyAction.$inject = [
    "$teve.userSession",
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.entities.Device",
    "$teve.licenseRestriction",
];

CopyAction.$displayDetails = {
    type: "Action",
    name: "CopyAction",
    icon: "common.copy",
    shown: true,
    title: "Copy IoT devices",
    order: 7,
};
